'use client';

import { JSX, PropsWithChildren } from 'react';

import { TypographyContext } from '@mo/ui';

export function TypographyProvider({ children }: PropsWithChildren) {

  return (
    <TypographyContext.Provider value={{ variable: true }}>
      {children as JSX.Element}
    </TypographyContext.Provider>
  );
}
